 

 <div style="max-width:400px; margin:0px auto;" class="col-xs-12">
        

        <div class="logo-wrapper">

            <img class="logo" src="assets/logo.png"  />
        </div>
        <p *ngIf="!messageSuccess" class="sub-title">Введіть ваш email, ми згенеруємо новий пароль і надішлемо нові дані для входу.</p>
        
        <div class="">
          <div>
           
            <form  *ngIf="!messageSuccess" [formGroup]="form" (ngSubmit)="submit()" >
              <div class="form-group">

                <div>
                  

                    <span class="label-with-link ">
                      <label for="email" class="label">Email:</label>
                       
                      </span>
  

                <input  nbInput    fullWidth  id="email" formControlName="email" 
                placeholder="Введіть email" type="email"
                [ngClass]="{invalid:form.get('email').invalid && form.get('email').touched}" />
              </div>
                <span *ngIf="form.get('email').invalid && form.get('email').touched" class="caption status-danger">
                 <span *ngIf="form.get('email').errors.required">Обов'язкове поле</span>
                 <span *ngIf="form.get('email').errors.email">Введіть коректну email адресу</span>
                </span>
              </div>
             

          

               <div > 
                     <re-captcha (error)="recaptchaResolved = false"  (resolved)="resolvedRecaptcha($event)" siteKey="6Le2awkbAAAAACfYFrY8WH11kn_BV3mIlWOrq5im"  ></re-captcha>
               </div>

              <div class="form-group submit-wrapper">
                <button  nbButton fullWidth size="large" status="primary"  [disabled]="form.invalid || form.disabled || !recaptchaResolved"
                type="submit">Скинути пароль</button>
              </div>
            </form>
	<div *ngIf="messageSuccess">
	<p style="text-align:center" >{{messageSuccess}}</p>
	   <div style="display:flex">

		<div style="display:flex; margin:auto; max-width:300px;">
		<button [routerLink]="['/login']" nbButton status="primary">Увійти</button>
			</div>
		</div>
           </div>
          </div>
 
      </div>
    </div>
  
